import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { AdvancedMarker, useMap } from '@vis.gl/react-google-maps';

import { ReactComponent as DealerLocationIcon } from 'Public/static/images/dealer-location-icon.svg';
import { ReactComponent as MapCarIcon } from 'Public/static/images/map-car-icon.svg';

import type { MarkersProps } from './DynamicMap.types';

import styles from './DynamicMap.module.scss';

export const Markers: React.FC<MarkersProps> = ({ isDealerMarkerVisible, locations }) => {
	const { dealer, seller } = locations;
	const [showMarkers, setShowMarkers] = useState(false);

	const map = useMap();

	useEffect(() => {
		const listener = map?.addListener('tilesloaded', () => {
			setShowMarkers(true);
		});

		return () => {
			listener?.remove();
		};
	}, [map]);

	if (!showMarkers) return null;

	const hasSellerLocation = seller.latitude && seller.longitude;

	if (!hasSellerLocation) return null;

	const shouldRenderDealerMarkers = isDealerMarkerVisible && dealer.latitude && dealer.longitude;

	return (
		<>
			{shouldRenderDealerMarkers ? (
				<AdvancedMarker position={{ lat: dealer.latitude!, lng: dealer.longitude! }}>
					<DealerLocationIcon
						aria-label="Dealer marker"
						className={cx(styles.marker, styles.dealerMarker)}
						role="graphics-document"
					/>
				</AdvancedMarker>
			) : null}

			<AdvancedMarker position={{ lat: seller.latitude!, lng: seller.longitude! }}>
				<MapCarIcon
					aria-label="Vehicle marker"
					className={cx([styles.marker, styles.vehicleMarker])}
					role="graphics-document"
				/>
			</AdvancedMarker>
		</>
	);
};
